import { useViewEvent } from 'features/events/context/ViewEvent';
import { useCheckout } from '..';

const useCheckoutSummary = () => {
  const data = [];
  const { event } = useViewEvent();
  const {
    checkoutSession: { checkoutSession }
  } = useCheckout();

  const eventPriceBreakdown = event?.pricing;
  const checkoutPriceBreakdown = checkoutSession?.pricing;
  const isHostPayingFees =
    eventPriceBreakdown?.transactionFeesPaidBy === 'host';

  if (checkoutPriceBreakdown?.discount) {
    data.push({
      subtitle: checkoutSession.discountCode?.code,
      title: 'discountCode',
      value: -checkoutPriceBreakdown.discount
    });
  }

  if (eventPriceBreakdown?.tax) {
    data.push({
      subtitle: eventPriceBreakdown.tax?.name,
      title: 'taxes',
      value: checkoutPriceBreakdown?.taxes
    });
  }

  data.push({
    subtitle: isHostPayingFees ? 'noFees' : 'paymentProcessingFees',
    title: isHostPayingFees ? 'fees' : 'processingFees',
    value: checkoutPriceBreakdown?.feesBreakdown.processingFees
  });

  if (!isHostPayingFees) {
    data.push({
      subtitle: 'perSelectedItemServiceFee',
      title: 'bounceFees',
      value: checkoutPriceBreakdown?.feesBreakdown.bounceFees
    });
  }

  if (
    checkoutPriceBreakdown?.feesBreakdown.eventOrganizerFees &&
    checkoutPriceBreakdown?.feesBreakdown.eventOrganizerFees > 0
  ) {
    data.push({
      subtitle: 'eventOrganizerFees',
      title: 'eventOrganizerFees',
      value: checkoutPriceBreakdown.feesBreakdown.eventOrganizerFees
    });
  }

  return data;
};

export default useCheckoutSummary;
